import * as React from 'react';
import {createHttpLink, InMemoryCache, TypePolicies} from '@apollo/client';
import {Header, useRequestHeader} from '@shopify/react-network';
import {GraphQLUniversalProvider} from '@shopify/react-graphql-universal-provider';
import {authenticatedFetch} from '@shopify/app-bridge/utilities';
import {appBridge} from 'packages/app-bridge';
import {isServer} from '@web-utilities/env';

import possibleTypes from '../../graphql/default-schema-possible-types.json';

export const typePolicies: TypePolicies = {
  QueryRoot: {
    queryType: true,
    fields: {
      onlineStore: {merge: true},
      shop: {merge: true},
    },
  },
  Shop: {
    fields: {
      features: {merge: true},
    },
  },
  Preview: {
    keyFields: ['urlWithPasswordBypass'],
  },
};

export function GraphQL({
  url,
  locale,
  children,
}: {
  url: URL;
  locale?: string;
  children?: React.ReactNode;
}) {
  const cookie = useRequestHeader('cookie');

  const createClientOptions = () => {
    const httpLinkOptions: {[key: string]: any} = {
      uri: `${url.origin}/graphql`,
      credentials: 'include',
      headers: {
        [Header.AcceptLanguage]: locale,
      },
      fetch: authenticatedFetch(appBridge, fetch),
    };

    if (isServer) {
      httpLinkOptions.headers = {
        ...httpLinkOptions.headers,
        cookie,
      };
    }

    const link = createHttpLink(httpLinkOptions);

    const cache = new InMemoryCache({
      possibleTypes,
      typePolicies,
    });

    return {link, cache, ssrMode: isServer};
  };

  return (
    <GraphQLUniversalProvider createClientOptions={createClientOptions}>
      {children}
    </GraphQLUniversalProvider>
  );
}
